<!-- Temp input -->
<input
  type="file"
  #fileInput
  style="display: none"
  (change)="onFileSelected($event)"
  multiple
  accept="image/*"
/>

<form [formGroup]="productDetailFormGroup">
  <div class="product-detail-container">
    <div class="product-details-left">
      <h6>Product Image</h6>
      <div
        class="upload-container"
        (mouseenter)="onProductImageMouseEntered()"
        (mouseleave)="onProductImageMouseLeave($event)"
      >
        <div
          class="re-upload-btn-container"
          (mouseenter)="onProductReuploadMouseEntered()"
          *ngIf="isProductImageMouseHover && productImageToUpload"
        >
          <button type="button" mat-flat-button (click)="fileInput.click()">
            Reupload
          </button>
        </div>
        <ng-container *ngIf="productImageToUploadLocalUrl">
          <img
            #uploadContainer
            (mouseenter)="onProductImageMouseEntered()"
            (mouseleave)="onProductImageMouseLeave($event)"
            [src]="productImageToUploadLocalUrl"
            alt=""
            [ngClass]="
              !isProductImageMouseHover
                ? 'img-opacity-1'
                : 'img-opacity-50-percent'
            "
          />
        </ng-container>
        <div class="upload-item" *ngIf="!productImageToUploadLocalUrl">
          <div>Drop files here to upload</div>
          <button
            type="button"
            mat-flat-button
            color="primary"
            (click)="fileInput.click()"
          >
            Browse file
          </button>
        </div>
      </div>
      <mat-error
        *ngIf="fileErrorMessage"
      >
        {{ fileErrorMessage }}
      </mat-error>
      <mat-error
        *ngIf="productDetailFormGroup.get('ImageUrl')?.hasError('required') && productDetailFormGroup.get('ImageUrl')?.touched"
      >
        Product Image is Required
      </mat-error>

      <mat-form-field class="w-full mt-2">
        <mat-label>Product Description</mat-label>
        <textarea matInput formControlName="Description"></textarea>
        <mat-error
          *ngIf="
            productDetailFormGroup.get('Description')?.hasError('required') &&
            productDetailFormGroup.get('Description')?.touched
          "
        >
          Product Description is Required
        </mat-error>
      </mat-form-field>
    </div>

    <div class="product-details-right">
      <h6>Product Details</h6>
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Product Name</mat-label>
        <input matInput formControlName="Name" required />
        <mat-error
          *ngIf="productDetailFormGroup.get('Name')?.hasError('required') && productDetailFormGroup.get('Name')?.touched"
        >
          Product Name is Required
        </mat-error>
      </mat-form-field>

      <!-- For Marts -->
      <mat-form-field appearance="fill" class="w-6 pr-1">
        <mat-label>Category</mat-label>
        <input
          matInput
          formControlName="Category"
          [matAutocomplete]="categoryAuto"
          placeholder="Search category..."
          (input)="filterCategories($any($event.target).value)"
        />
        <mat-autocomplete
          #categoryAuto="matAutocomplete"
          [displayWith]="displayCategoryFn"
          (optionSelected)="onCategorySelected($event)"
        >
          <mat-option
            *ngFor="let category of filteredCategories"
            [value]="category"
          >
            {{ category.Name }}
          </mat-option>
        </mat-autocomplete>
        <mat-error
          *ngIf="productDetailFormGroup.get('Category')?.hasError('required') && productDetailFormGroup.get('Category')?.touched"
        >
          Category is Required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill" class="w-6 pl-1">
        <mat-label>Subcategory</mat-label>
        <mat-select formControlName="Subcategory">
          <mat-option
            *ngFor="let subCategory of subProductCategories"
            [value]="subCategory"
          >
            {{ subCategory.Name }}
          </mat-option>
        </mat-select>
        <mat-error
          *ngIf="
            productDetailFormGroup.get('Subcategory')?.hasError('required') &&
            productDetailFormGroup.get('Subcategory')?.touched
          "
        >
          Sub-category is required.
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill" class="w-full">
        <mat-label>SKU (optional)</mat-label>
        <input matInput formControlName="SKU" />
      </mat-form-field>
      <h6 class="pt-0">Tags (Optional)</h6>
      <p>
        TIP: Use Tags help inform customers about dietary requirements (example
        Vegan)
      </p>

      <div class="flex justify-content-between">
        <mat-form-field appearance="fill" class="w-10">
          <mat-label>Tags</mat-label>
          <mat-select formControlName="Tags" [(ngModel)]="selectedTags">
            <mat-option *ngFor="let tag of tags" [value]="tag">
              {{ tag.Name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <button
          type="button"
          mat-mini-fab
          color="primary"
          class="ml-1"
          (click)="addTags(selectedTags)"
          [disabled]="!selectedTags"
        >
          <mat-icon>add</mat-icon>
        </button>
      </div>

      <mat-chip-listbox>
        <mat-chip
          *ngFor="let tag of selectedTagList"
          color="primary"
          selected
          (removed)="removeSelectedTags(tag)"
        >
          {{ tag.Name }}
          <button type="button" matChipRemove>
            <mat-icon>close</mat-icon>
          </button>
        </mat-chip>
      </mat-chip-listbox>
    </div>
  </div>
</form>
